import { RootState } from "types";
import { initialState } from "./initialState";
import { createSelector } from "@reduxjs/toolkit";

const selectDomain = (state: RootState) =>
  state?.mySettingState || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.isLoading
);

export const selectFormValues = createSelector(
  [selectDomain],
  (state) => state.form
);

export const selectCheckPassword = createSelector(
  [selectDomain],
  (state) => state.hasPassword
);
export const selectButtonLoading = createSelector(
  [selectDomain],
  (state) => state.buttonLoading
);

export const selectVerifyCodeError = createSelector(
  [selectDomain],
  (state) => state.verifyCodeError
);

export const selectChangeEmailRequestId = createSelector(
  [selectDomain],
  (state) => state.changeEmailRequestId
);
